import { useState } from "react";
import { faqs } from "@/mocks/watchGuide";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  const toggle = (id: string) => {
    setOpenId((cur) => (cur === id ? null : id));
  };

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)] gap-8 lg:gap-14">
          <SectionHeading
            eyebrow="常见问答"
            title="关于中文字幕，大家问得最多的几个问题"
            desc="如果你刚接触日韩剧集，先把这些问题理清，基本就能顺畅开看了。"
          />

          <div className="divide-y divide-background-200/70 border-t border-b border-background-200/70">
            {faqs.map((f) => {
              const isOpen = openId === f.id;
              return (
                <div key={f.id}>
                  <button
                    onClick={() => toggle(f.id)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 py-4 md:py-5 text-left cursor-pointer"
                  >
                    <span className="font-heading text-sm md:text-base font-medium text-foreground-950">
                      {f.q}
                    </span>
                    <span
                      className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition-colors ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-50 text-foreground-600 border border-background-300/70"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      isOpen ? "max-h-60 pb-5" : "max-h-0"
                    }`}
                  >
                    <p className="text-sm text-foreground-600 leading-relaxed pr-10">{f.a}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}